import { createContext, useState, useContext } from "react";
import PropTypes from "prop-types";

const PersonsFilterContext = createContext(null);

export const PersonsFilterProvider = ({ children }) => {
  // ==================== LISTA DE PERSONAS ====================
  const [personsFilters, setPersonsFilters] = useState({
    viewType: "cards",
    searchInputValue: "",
    activeSearchFilter: "",
    currentPage: 1,
    localFilters: {
      roleId: null,
      documentFilter: "all",
      documentType: "required",
      activeStatus: "active",
      documentTypeIds: [],
      missingDocuments: false,
    },
  });

  // ==================== DOCUMENTO SELECCIONADO ====================
  const [selectedUser, setSelectedUser] = useState(null);
  const [currentDocumentType, setCurrentDocumentType] = useState("required");
  const [documentFilter, setDocumentFilter] = useState("all");
  const [usersListScrollTop, setUsersListScrollTop] = useState(0);

  // ==================== SETTERS LISTA ====================
  const setPersonsViewType = (viewType) => {
    setPersonsFilters(prev => ({ ...prev, viewType }));
  };

  const setPersonsSearchInputValue = (searchInputValue) => {
    setPersonsFilters(prev => ({ ...prev, searchInputValue }));
  };

  const setPersonsActiveSearchFilter = (activeSearchFilter) => {
    setPersonsFilters(prev => ({ ...prev, activeSearchFilter }));
  };

  const setPersonsCurrentPage = (currentPage) => {
    setPersonsFilters(prev => ({ ...prev, currentPage }));
  };

  const setPersonsLocalFilters = (localFilters) => {
    setPersonsFilters(prev => ({ ...prev, localFilters }));
  };

  const clearPersonsFilters = () => {
    setPersonsFilters({
      viewType: "cards",
      searchInputValue: "",
      activeSearchFilter: "",
      currentPage: 1,
      localFilters: {
        roleId: null,
        documentFilter: "all",
        documentType: "required",
        activeStatus: "active",
        documentTypeIds: [],
        missingDocuments: false,
      },
    });
    setSelectedUser(null);
    setCurrentDocumentType("required");
    setDocumentFilter("all");
    setUsersListScrollTop(0);
  };

  const value = {
    // Estado lista
    personsFilters,
    setPersonsViewType,
    setPersonsSearchInputValue,
    setPersonsActiveSearchFilter,
    setPersonsCurrentPage,
    setPersonsLocalFilters,
    clearPersonsFilters,

    // Estado panel de documentos del usuario seleccionado
    selectedUser,
    setSelectedUser,
    currentDocumentType,
    setCurrentDocumentType,
    documentFilter,
    setDocumentFilter,
    usersListScrollTop,
    setUsersListScrollTop,
  };

  return (
    <PersonsFilterContext.Provider value={value}>
      {children}
    </PersonsFilterContext.Provider>
  );
};

export const usePersonsFilter = () => {
  const context = useContext(PersonsFilterContext);
  if (!context) {
    throw new Error("usePersonsFilter debe ser usado dentro de PersonsFilterProvider");
  }
  return context;
};

PersonsFilterProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
